
  /**
   * @license
   * author: epignosis front-end team
   * @epignosis_llc/gnosis.js v6.0.0
   * Released under the MIT license.
   */

var ModalPortal = {exports: {}};

export { ModalPortal as M };
//# sourceMappingURL=ModalPortal.js.map
